import Ajax from '../../../../common/js/Ajax.js';
import Dialog from '../../../../common/js/dialog/Dialog.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import Widget from '../../../../common/js/Widget.js';
import WidgetLoader from '../../../../common/js/WidgetLoader.js';
import DropDownWidget from '../../../../common/js/dropdown/DropDownWidget.js';

import TEMPLATE from './TasksWidget.hbs';
import TASK_OUTPUT_TEMPLATE from './TasksWidget-task-output.hbs';

function filterRelevantClocks(clocks) {
	return clocks.filter(clock => clock.seconds >= 30);
}

export default class TasksWidget extends Widget {
	constructor($widget) {
		super($widget);

		Ajax.rpc(
			'/isLoggedIn',
			loggedIn => {
				if (loggedIn) {
					this.show();
					this.refreshAll();
					window.setInterval(() => this.updateRunningClock(), 10000);
					window.setInterval(() => this.checkModified(), 60000);
				} else {
					window.location.href = '/login';
				}

				$('.js_pause-button').click(() => {
					this.pause();
				});

				$(document).keydown(event => {
					if (event.which == 27) {
						this.pause();
					}
				});
			},
			error => {
				this.show();
				MessageUtils.error($widget, 'Fehler beim Überprüfen des Logins', error);
			}
		);
	}

	refreshAll(callback) {
		const widget = this;

		Ajax.rpc('/projects', response => {
			const {projects, modificationDate} = response;
			this.modificationDate = modificationDate;

			this.tasks = {};
			let hasTasks = false;
			for (const project of projects) {
				for (var task of project.tasks) {
					widget.updateTaskTag(task);
					this.tasks[task.id] = task;
					hasTasks = true;
				}
			}

			this.$widget.html(TEMPLATE({projects, hasTasks}));
			this.updateTaskTimes();
			this.runningClockStart = new Date().getTime();
			WidgetLoader.initialize();

			$('.js_pause-button').toggle(this.isAnyRunning());

			this.editField(this.$widget.find('.section__name__input'), ($input, name) => {
				const projectId = parseInt($input.closest('.section').attr('data-id'), 10);
				const $nameOutput = $input.closest('.section__name').find('.section__name__output');
				$nameOutput.text(name);
				widget.setSaving(true);
				Ajax.rpc('/saveProject', {projectId, name}, () => {
					widget.refreshAll();
					widget.setSaving(false);
				});

				return true;
			});

			$('.section__delete').click(function () {
				const $project = $(this).closest('.section');
				if ($project.find('.task').length) {
					Dialog.warning('Cannot delete project', 'This project has tasks, please delete them first.');
					return;
				}

				const projectId = $project.attr('data-id');
				widget.setSaving(true);
				Ajax.rpc('/deleteProject', {projectId}, () => {
					widget.refreshAll();
					widget.setSaving(false);
				});
			});

			this.$widget.find('.task__start-stop').click(function () {
				widget.updateRunningClock();
				const taskId = parseInt($(this).closest('.task').attr('data-id'), 10);
				const running = !$(this).hasClass('button-secondary');
				if (running) {
					widget.setSaving(true);
					Ajax.rpc('/stopClock', () => {
						widget.refreshAll();
						widget.setSaving(false);
					});
				} else {
					widget.setSaving(true);
					Ajax.rpc('/startClock', {taskId}, () => {
						widget.refreshAll();
						widget.setSaving(false);
					});
				}
			});

			this.$widget.find('.task__priority .form__input--drop-down').change(function () {
				const taskId = parseInt($(this).closest('.task').attr('data-id'), 10);
				const priority = DropDownWidget.getValue($(this));
				widget.setSaving(true);
				Ajax.rpc('/saveTask', {taskId, priority}, () => {
					widget.refreshAll();
					widget.setSaving(false);
				});
			});

			this.editField(this.$widget.find('.task__time__input'), ($input, time) => {
				const taskId = parseInt($input.closest('.task').attr('data-id'), 10);
				time = time.trim();
				var factor;
				var seconds;
				if (time.match(/^\+.*$/)) {
					factor = 1;
					seconds = this.parseSeconds(time.substring(1));
				} else if (time.match(/^-.*$/)) {
					factor = -1;
					seconds = this.parseSeconds(time.substring(1));
				} else {
					factor = 0;
					seconds = this.parseSeconds(time);
				}

				if (seconds === undefined) {
					return false;
				}

				if (seconds < 0 || seconds >= 24 * 60 * 60) {
					window.setTimeout(() => {
						Dialog.warning(
							'Invalid time',
							'Please provide a valid time in one of the following formats:\n\n' + '2:30, 2h, 15m, +1:15, -3h, 0'
						);
					}, 1);
					return false;
				}

				if (factor === 0) {
					widget.setSaving(true);
					Ajax.rpc('/setTime', {taskId, seconds, day: new Date()}, () => {
						widget.refreshAll();
						widget.setSaving(false);
					});
				} else {
					widget.setSaving(true);
					Ajax.rpc('/addTime', {taskId, seconds: seconds * factor, day: new Date()}, () => {
						widget.refreshAll();
						widget.setSaving(false);
					});
				}

				return true;
			});

			this.editField(this.$widget.find('.task__name__input'), ($input, name) => {
				const taskId = parseInt($input.closest('.task').attr('data-id'), 10);
				const task = widget.tasks[taskId];
				task.name = name;
				widget.updateTaskTag(task);
				const $nameOutput = $input.closest('.task__name').find('.task__name__output');
				$nameOutput.html(TASK_OUTPUT_TEMPLATE(task));
				widget.setSaving(true);
				Ajax.rpc('/saveTask', {taskId, name}, () => {
					widget.refreshAll();
					widget.setSaving(false);
				});

				return true;
			});

			this.$widget.find('.task__toggle-comment').click(function () {
				const taskId = parseInt($(this).closest('.task').attr('data-id'), 10);
				const $taskComment = $('.task__comment[data-id="' + taskId + '"]');
				const show = $taskComment.hasClass('hidden');
				$taskComment.toggleClass('hidden', !show);
				$(this).toggleClass('button-secondary', !show);
			});

			$('.task__comment textarea').blur(function () {
				const $comment = $(this);
				const taskId = parseInt($comment.closest('.task__comment').attr('data-id'), 10);
				widget.setSaving(true);
				Ajax.rpc('/saveTask', {taskId, comment: $comment.val().trim() || '%'}, () => {
					widget.refreshAll();
					widget.setSaving(false);
				});
			});

			$('.task__delete').click(function () {
				const taskId = parseInt($(this).closest('.task').attr('data-id'), 10);
				if (filterRelevantClocks(widget.tasks[taskId].clocks).length) {
					Dialog.warning('Cannot delete task', 'This task has clocks, please export them first.');
					return;
				}

				widget.setSaving(true);
				Ajax.rpc('/deleteTask', {taskId}, () => {
					widget.refreshAll();
					widget.setSaving(false);
				});
			});

			$('.section__add-task').click(function () {
				const projectId = parseInt($(this).closest('.section').attr('data-id'), 10);
				widget.setSaving(true);
				Ajax.rpc('/saveTask', {projectId}, taskId => {
					widget.refreshAll(() => {
						const $task = $('.task[data-id="' + taskId + '"] .task__name__input');
						// Need to show temporarily to focus
						$task.css('display', 'block');
						$task.focus();
						$task.css('display', undefined);
					});
					widget.setSaving(false);
				});
			});

			$('.sections__add button').click(function () {
				widget.setSaving(true);
				Ajax.rpc('/saveProject', () => {
					widget.refreshAll();
					widget.setSaving(false);
				});
			});

			if (callback) {
				callback();
			}
		});
	}

	updateTaskTag(task) {
		const tagMatch = task.name.match(/^(#[\S]+)(.*)$/);
		if (tagMatch) {
			task.tag = tagMatch[1];
			task.nameWithoutTag = tagMatch[2];
		} else {
			task.tag = '';
			task.nameWithoutTag = task.name;
		}
	}

	updateTaskTimes() {
		let totalMinutes = 0;
		const totalMinutesByProject = {};
		let anyOtherClock = false;
		for (const taskId in this.tasks) {
			const task = this.tasks[taskId];
			const relevantClocks = filterRelevantClocks(task.clocks);

			let todayClock = undefined;
			for (const clock of relevantClocks) {
				if (clock.day.toString('yyyyMMdd') === new Date().toString('yyyyMMdd')) {
					todayClock = clock;
				}
			}

			const otherClock = relevantClocks.length >= 2 || (!todayClock && relevantClocks.length);
			anyOtherClock = anyOtherClock || otherClock;
			const minutes = todayClock ? Math.round(todayClock.seconds / 60) : 0;
			totalMinutes += minutes;

			const $task = $('.task[data-id="' + task.id + '"]');
			const projectId = $task.closest('.section').attr('data-id');
			const projectMinutes = totalMinutesByProject[projectId] || 0;
			projectMinutes += minutes;
			totalMinutesByProject[projectId] = projectMinutes;

			const timeString = this.formatMinutes(minutes);
			$('.task[data-id="' + task.id + '"] .task__time__output').html(timeString + (otherClock ? '+' : '&nbsp;'));

			const $input = $('.task[data-id="' + task.id + '"] .task__time__input');
			if (!$input.is(':focus')) {
				$input.val(timeString + (otherClock ? '+' : ' '));
			}
		}

		$('.site-description')
			.text(totalMinutes > 0 ? `Today: ${this.formatMinutes(totalMinutes)}` : 'Task management and time recording')
			.toggleClass('desktop-only', totalMinutes <= 0);

		$('.js_export-button').toggle(totalMinutes > 0 || anyOtherClock);

		$('.section').each((index, project) => {
			const $project = $(project);
			const projectMinutes = totalMinutesByProject[$project.attr('data-id')] || 0;
			const $projectMinutes = $project.find('.section__clock-summary');
			$projectMinutes.text(`Today: ${this.formatMinutes(projectMinutes)}`);
			$projectMinutes.toggle(projectMinutes > 0);
		});
	}

	updateRunningClock() {
		const differenceSeconds = parseInt((new Date().getTime() - this.runningClockStart) / 1000);
		if (differenceSeconds <= 0) {
			return;
		}

		this.runningClockStart += differenceSeconds * 1000;

		for (const taskId in this.tasks) {
			const task = this.tasks[taskId];
			if (task.running) {
				for (const clock of task.clocks) {
					if (clock.day.toString('yyyyMMdd') === new Date().toString('yyyyMMdd')) {
						clock.seconds += differenceSeconds;
						this.updateTaskTimes();
						return;
					}
				}
			}
		}
	}

	checkModified() {
		const widget = this;

		Ajax.rpc('/lastChange', modificationDate => {
			if (this.modificationDate && this.modificationDate.getTime() !== modificationDate.getTime()) {
				this.modificationDate = null;
				widget.refreshAll();
			}
		});
	}

	formatMinutes(minutes) {
		if (minutes <= 0) {
			return '';
		}

		const hours = Math.floor(minutes / 60);
		minutes -= hours * 60;

		return (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
	}

	isAnyRunning() {
		for (const taskId in this.tasks) {
			if (this.tasks[taskId].running) return true;
		}

		return false;
	}

	editField($inputs, callback) {
		$inputs.each((index, input) => {
			const $input = $(input);
			$input.focus(function () {
				$input.attr('data-old', $input.val());
				input.setSelectionRange(0, $input.val().length);
			});

			$input.blur(function () {
				const value = $input.val();
				const oldValue = $input.attr('data-old');
				if (value !== oldValue) {
					const success = callback($input, value);
					if (!success) {
						$input.val(oldValue);
					}
				}
			});

			$input.keydown(function (event) {
				if (event.which == 13) {
					$input.blur();
				} else if (event.which == 27) {
					const oldValue = $input.attr('data-old');
					$input.val(oldValue);
					$(this).blur();
				}
			});
		});
	}

	parseSeconds(string) {
		string = string.trim();

		var match = string.match(/^([0-9]+):([0-9][0-9])$/);
		if (match) {
			return parseInt(match[1], 10) * 3600 + parseInt(match[2], 10) * 60;
		}

		if (string.match(/^[0-9]+([,.][0-9]+|)h?$/)) {
			return Math.round(parseFloat(string.replace(',', '.')) * 3600);
		}

		if (string.match(/^[0-9]+([,.][0-9]+|)m$/)) {
			return Math.round(parseFloat(string.replace(',', '.')) * 60);
		}

		return undefined;
	}

	setSaving(saving) {
		$('.saving').remove();
		if (saving) {
			$('#page').append('<div class="saving"></div>');
		}
	}

	pause() {
		this.setSaving(true);
		Ajax.rpc('/stopClock', () => {
			this.refreshAll();
			this.setSaving(false);
		});
	}
}
